<div class=" term-condition">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h4 class="">Terms & Conditions</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="terms-content">
        <p [innerHTML]="successResponse"></p>
      </div>
    </div>
  </div>
 <!-- Don't show for Guest Sign up when we clickon Terms and condns link. -->
 <div *ngIf="!isGuestSignUp">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center bg-white check-shadow">
    <div class="form-group form-margin">
      <div class="checkbox custom-sm-checkbox">
        <input id="agree" type="checkbox" [checked]="isAgree" (change)="isAgree = !isAgree" />
        <label for="agree"> I have read the terms and conditions</label>
      </div>
    </div>
  </div>
  <div class="row" >
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <div class="form-group wab-btn-footer">
        <button type="submit" class="btn wb-btn-default center-block" name="signup" value="Sign up" [disabled]="(!this.isAgree || loading)" (click)="onTermsAccepted()">
          Agree
          <span *ngIf="loading" class="loading-animation"></span>
        </button>
        <span role="button" (click)="showSignupModal()"  type="submit" class="btn wb-btn-outline center-block" name="signup" value="Sign up">Do Not Agree</span>
      </div>
    </div>
  </div>
</div>
</div>
